export const ROUTES = {
  INDEX: "/",
  ACCEPTABLE_USE_POLICY: "/acceptable-use-policy",
  USER_GUIDE: "/user-guide",
  FAQ: "/faq",
  LOGOUT: "/logout",
};
